if (!customElements.get('eds-energy-product-problem')) {
  customElements.define(
    'eds-energy-product-problem',
    class EdsEnergyProductProblem extends HTMLElement {
      connectedCallback() {
        this.scroll = this.querySelector('[data-comparison-scroll]');
        this.previousButton = this.querySelector('.eds-energy-product-problem__arrow--previous');
        this.nextButton = this.querySelector('.eds-energy-product-problem__arrow--next');
        this.step = 190;

        this.previousButton?.addEventListener('click', () => this.move(-this.step));
        this.nextButton?.addEventListener('click', () => this.move(this.step));
        this.scroll?.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons());
        this.updateButtons();
      }

      move(offset) {
        this.scroll?.scrollBy({ left: offset, behavior: 'smooth' });
      }

      updateButtons() {
        if (!this.scroll) return;

        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        const maxScroll = this.scroll.scrollWidth - this.scroll.clientWidth;

        if (this.previousButton) this.previousButton.disabled = isDesktop || this.scroll.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = isDesktop || this.scroll.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
